import { useState, useEffect } from 'react'
//import './style.scss';


export const AparCategoryView = (props) => {

  const [categoryName, updateCategoryName] = useState("");

  useEffect(() => {
    if (props.value) {
      let { value } = props;
      updateCategoryName(value);
    }

  }, []);

  return (

    <>
      <div className={`addRole`} >
        <div className="user-body">
          <div className="userList">
            <div className="userNameLabel">
              <span>Category Name</span>
            </div>
            <div className="userNameOutput">
              <input type="text" id="txtRole" value={categoryName} onChange={(event) => updateCategoryName(event.target.value)}></input>
            </div>

          </div>
        </div>

        <div className="user-footer text-end">
          <button className="mla fs12 primary mini" onClick={() => props.saveCategory(categoryName)}>Add</button>
        </div>
      </div>
    </>
  );
};

export default AparCategoryView